const initPendo = (userData, manufacturerData) => {
  if (!userData?.id) return;

  const initializePendo = () => {
    const visitorId = userData.id.toString();
    const accountId = manufacturerData?.platform_id?.toString() || 'unknown-manufacturer';

    const visitorData = {
      id: visitorId,
      email: userData.email,
      full_name: userData.first_name + ' ' + userData.last_name,
      admin: userData.internalAdmin,
    };

    const accountData = {
      id: accountId,
      name: manufacturerData?.nickname || 'Unknown Manufacturer',
    };

    if (window.pendo && window.__pendo_initialized__) {
      window.pendo.identify({
        visitor: visitorData,
        account: accountData,
      });
      return;
    }

    if (window.pendo) {
      window.pendo.initialize({
        visitor: visitorData,
        account: accountData,
      });

      window.__pendo_initialized__ = true;
    } else {
      console.error('Pendo is not available.');
    }
  };

  const waitForPendo = (attempts = 0) => {
    if (window.pendo) {
      initializePendo();
    } else if (attempts < 10) {
      setTimeout(() => waitForPendo(attempts + 1), 300);
    } else {
      console.error('Pendo script not loaded after multiple attempts.');
    }
  };

  waitForPendo();
};

export default initPendo;
